import { jsPDF } from 'jspdf';
import { clientsData } from '../data/mock';

/**
 * Brochure Corporativo Analytica - Estilo flyer visual.
 * Layout libre con hero, iconos grandes, timelines, badges y casos de éxito.
 */

const BRAND = {
  navy: [47, 61, 142],       // #2F3D8E
  navyDark: [26, 36, 86],    // #1a2456
  blue: [93, 165, 216],      // #5DA5D8
  green: [76, 140, 59],      // #4C8C3B
  greenDark: [61, 112, 48],
  gray: [120, 120, 130],
  grayLight: [240, 240, 245],
  white: [255, 255, 255],
  text: [40, 45, 60],
};

const FOOTER_LINE_1 = 'Analytica · Av. Naciones Unidas y Núñez de Vela, Edif. Metropolitan 3er piso · Quito, Ecuador';
const FOOTER_LINE_2 = 'www.analytica-ec.com    +593 991 466 821    gerencia@analytica-ec.com';

// ---- helpers ----
const setFill = (doc, c) => doc.setFillColor(c[0], c[1], c[2]);
const setText = (doc, c) => doc.setTextColor(c[0], c[1], c[2]);
const setStroke = (doc, c) => doc.setDrawColor(c[0], c[1], c[2]);

const drawFooter = (doc, pageLabel) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  setStroke(doc, BRAND.navy);
  doc.setLineWidth(0.3);
  doc.line(14, h - 14, w - 14, h - 14);
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text(FOOTER_LINE_1, w / 2, h - 9, { align: 'center' });
  doc.text(FOOTER_LINE_2, w / 2, h - 5.5, { align: 'center' });
  if (pageLabel) {
    setText(doc, BRAND.navy);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(pageLabel, w - 14, h - 5.5, { align: 'right' });
  }
};

// Wrap text helper that returns array of lines
const wrapText = (doc, text, maxWidth) => doc.splitTextToSize(text, maxWidth);

// ---- PAGE 1: COVER ----
const drawCover = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();

  // Background full navy
  setFill(doc, BRAND.navyDark);
  doc.rect(0, 0, w, h, 'F');

  // Decorative diagonal accent
  setFill(doc, BRAND.navy);
  doc.triangle(0, h, w * 0.6, h, 0, h * 0.45, 'F');
  setFill(doc, BRAND.blue);
  doc.triangle(w, 0, w, h * 0.4, w * 0.55, 0, 'F');
  setFill(doc, BRAND.green);
  doc.triangle(w, 0, w, h * 0.18, w * 0.78, 0, 'F');

  // Dots pattern (subtle)
  setFill(doc, [255, 255, 255]);
  for (let x = 25; x < w; x += 14) {
    for (let y = 30; y < 90; y += 14) {
      doc.circle(x, y, 0.4, 'F');
    }
  }

  // Brand mark
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(36);
  doc.text('ANALYTICA', 22, 60);
  // Underline accent
  setFill(doc, BRAND.green);
  doc.rect(22, 64, 70, 1.6, 'F');

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  setText(doc, [200, 215, 245]);
  doc.text('Soluciones de Software & Analítica Avanzada', 22, 72);

  // Tagline (hero)
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(40);
  setText(doc, BRAND.white);
  doc.text('Datos.', 22, 130);
  doc.text('Decisiones.', 22, 148);
  setText(doc, BRAND.green);
  doc.text('Resultados.', 22, 166);

  // Sub-description
  setText(doc, [220, 230, 250]);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  const sub = wrapText(doc, 'Convertimos información en ventaja competitiva. Diseñamos software a medida, dashboards inteligentes y modelos analíticos que aceleran tus decisiones.', w - 90);
  doc.text(sub, 22, 185);

  // Bottom badge
  setFill(doc, BRAND.green);
  doc.roundedRect(22, h - 40, 60, 12, 2, 2, 'F');
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('BROCHURE 2026', 52, h - 32, { align: 'center' });

  // Contact line at bottom
  setText(doc, [200, 215, 245]);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text('www.analytica-ec.com   ·   +593 991 466 821   ·   Quito, Ecuador', 22, h - 18);
};

// ---- PAGE 2: QUIÉNES SOMOS ----
const drawAbout = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  // Section label
  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('01  ·  QUIÉNES SOMOS', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(28);
  doc.text('Analítica que mueve', 14, y);
  setText(doc, BRAND.green);
  doc.text('tu negocio.', 14, y + 11);

  y += 28;
  setText(doc, BRAND.text);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  const para1 = wrapText(doc,
    'Analytica es una firma especializada en transformar datos en decisiones. Combinamos ingeniería de software de alto nivel, ciencia de datos aplicada e inteligencia artificial generativa para construir soluciones que las empresas usan, miden y rentabilizan.',
    w - 28);
  doc.text(para1, 14, y);
  y += para1.length * 5.5 + 4;

  const para2 = wrapText(doc,
    'No entregamos reportes que terminan en un cajón. Construimos plataformas operativas — dashboards en vivo, motores de pricing, módulos de QA, contratos digitales y asistentes IA — que tu equipo abre cada día y que cambian la forma en que el negocio toma decisiones.',
    w - 28);
  doc.text(para2, 14, y);
  y += para2.length * 5.5 + 8;

  // Stat cards (3 cols)
  const cardW = (w - 28 - 12) / 3;
  const stats = [
    { v: '+800K', l: 'filas procesadas\npor cliente al mes' },
    { v: '<24h', l: 'tiempo de cierre\nde contratos digitales' },
    { v: '12+', l: 'módulos productivos\ndesplegados' },
  ];
  stats.forEach((s, i) => {
    const x = 14 + i * (cardW + 6);
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(x, y, cardW, 34, 3, 3, 'F');
    setFill(doc, BRAND.green);
    doc.rect(x, y, 2, 34, 'F');
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(20);
    doc.text(s.v, x + 6, y + 13);
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    const lines = s.l.split('\n');
    lines.forEach((ln, idx) => doc.text(ln, x + 6, y + 21 + idx * 4.5));
  });

  y += 50;

  // Misión / Visión side by side
  const colW = (w - 28 - 6) / 2;
  // Misión
  setFill(doc, BRAND.navy);
  doc.roundedRect(14, y, colW, 42, 3, 3, 'F');
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('MISIÓN', 20, y + 9);
  setFill(doc, BRAND.green);
  doc.rect(20, y + 11, 14, 0.8, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  const mision = wrapText(doc,
    'Empoderar a las organizaciones con software analítico que acelera decisiones y multiplica resultados medibles.',
    colW - 12);
  doc.text(mision, 20, y + 19);

  // Visión
  const x2 = 14 + colW + 6;
  setFill(doc, BRAND.green);
  doc.roundedRect(x2, y, colW, 42, 3, 3, 'F');
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('VISIÓN', x2 + 6, y + 9);
  setFill(doc, BRAND.white);
  doc.rect(x2 + 6, y + 11, 14, 0.8, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  const vision = wrapText(doc,
    'Ser el aliado regional de referencia en analítica y software, reconocido por la calidad técnica y el impacto real en cada cliente.',
    colW - 12);
  doc.text(vision, x2 + 6, y + 19);

  drawFooter(doc, '02');
};

// ---- PAGE 3: SERVICIOS ----
const drawServices = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('02  ·  SERVICIOS', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.text('Lo que hacemos.', 14, y);

  y += 6;
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Seis líneas de servicio que se combinan en un solo ecosistema.', 14, y + 6);

  y += 16;

  const services = [
    { num: '01', t: 'Inteligencia de Mercado',
      d: 'Análisis estadístico de elasticidad precio-demanda, segmentación geográfica y de canal, pricing dinámico sobre +800K filas mensuales.',
      c: BRAND.navy },
    { num: '02', t: 'Software a Medida',
      d: 'Aplicaciones full-stack en React y FastAPI. Arquitectura escalable, APIs documentadas y despliegue continuo.',
      c: BRAND.green },
    { num: '03', t: 'Dashboards & BI',
      d: 'Visualización en tiempo real con Recharts y D3. KPIs, alertas y exportación profesional a Excel y PDF.',
      c: BRAND.blue },
    { num: '04', t: 'IA Generativa',
      d: 'Recomendaciones con GPT-5.2, transcripción Whisper, análisis de video y agentes contextuales sobre tu data.',
      c: BRAND.navy },
    { num: '05', t: 'QA & Validación',
      d: 'Test plans estilo Azure DevOps con trazabilidad de requisitos, evidencia adjunta y aceptación firmada del cliente.',
      c: BRAND.green },
    { num: '06', t: 'Contratos Digitales',
      d: 'Firma electrónica dual, certificado con hash blockchain, generación de PDF profesional y registro auditable.',
      c: BRAND.blue },
  ];

  const colW = (w - 28 - 6) / 2;
  const rowH = 40;
  services.forEach((s, i) => {
    const col = i % 2;
    const row = Math.floor(i / 2);
    const x = 14 + col * (colW + 6);
    const yy = y + row * (rowH + 4);
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(x, yy, colW, rowH, 2.5, 2.5, 'F');
    // Number badge
    setFill(doc, s.c);
    doc.roundedRect(x + 4, yy + 4, 16, 16, 2, 2, 'F');
    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(s.num, x + 12, yy + 14, { align: 'center' });
    // Title
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(s.t, x + 24, yy + 12);
    // Desc
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    const lines = wrapText(doc, s.d, colW - 28);
    doc.text(lines, x + 24, yy + 19);
  });

  drawFooter(doc, '03');
};

// ---- PAGE 4: METODOLOGÍA ----
const drawMethodology = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('03  ·  CÓMO LO HACEMOS', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.text('Metodología en 6 pasos.', 14, y);

  y += 6;
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Un proceso claro, iterativo y con entregables verificables en cada etapa.', 14, y + 6);

  y += 18;

  const steps = [
    { n: '01', t: 'Diagnóstico', d: 'Inmersión en tu operación, levantamiento de procesos y data disponible. Mapeo de oportunidades.' },
    { n: '02', t: 'Propuesta Formal', d: 'Documento estructurado con objetivo, alcance, plan de ejecución, beneficios y propuesta financiera.' },
    { n: '03', t: 'Diseño & Arquitectura', d: 'Wireframes, modelo de datos, definición de stack y plan de despliegue. Aprobación del cliente antes de codear.' },
    { n: '04', t: 'Desarrollo Iterativo', d: 'Sprints quincenales con demos en vivo. Builds estables y feedback continuo.' },
    { n: '05', t: 'QA & Aceptación', d: 'Plan de pruebas con trazabilidad de requisitos. Cliente firma aceptación caso por caso desde la app.' },
    { n: '06', t: 'Despliegue & Soporte', d: 'Producción con monitoreo. Soporte continuo, mantenimiento evolutivo y capacitación al equipo.' },
  ];

  // Vertical timeline
  const lineX = 30;
  setStroke(doc, BRAND.blue);
  doc.setLineWidth(0.7);
  doc.line(lineX, y, lineX, y + steps.length * 24);

  steps.forEach((s, i) => {
    const yy = y + i * 24;
    // Dot
    setFill(doc, i % 2 === 0 ? BRAND.navy : BRAND.green);
    doc.circle(lineX, yy + 6, 4.5, 'F');
    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(s.n, lineX, yy + 7.5, { align: 'center' });
    // Card
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(lineX + 10, yy, w - lineX - 10 - 14, 20, 2, 2, 'F');
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(s.t, lineX + 15, yy + 8);
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    const ln = wrapText(doc, s.d, w - lineX - 30);
    doc.text(ln, lineX + 15, yy + 14);
  });

  drawFooter(doc, '04');
};

// ---- PAGE 5: STACK ----
const drawStack = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('04  ·  STACK TECNOLÓGICO', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.text('Tecnología de punta.', 14, y);

  y += 6;
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Stack moderno, probado en producción y respaldado por comunidades activas.', 14, y + 6);

  y += 20;

  const groups = [
    { title: 'BACKEND', color: BRAND.navy,
      items: ['Python 3.12', 'FastAPI', 'Pydantic v2', 'Node.js', 'MongoDB', 'PostgreSQL', 'Redis'] },
    { title: 'FRONTEND', color: BRAND.green,
      items: ['React 19', 'Next.js', 'TypeScript', 'Tailwind CSS', 'shadcn/ui', 'Recharts', 'jsPDF'] },
    { title: 'IA & DATOS', color: BRAND.blue,
      items: ['OpenAI GPT-5.2', 'Whisper STT', 'Pandas', 'NumPy', 'SciPy', 'scikit-learn'] },
    { title: 'INFRA & DEVOPS', color: BRAND.navyDark,
      items: ['Kubernetes', 'Docker', 'AWS', 'Cloudflare', 'GitHub Actions', 'Supervisor'] },
  ];

  const groupH = 38;
  groups.forEach((g, i) => {
    const yy = y + i * (groupH + 6);
    // Title band
    setFill(doc, g.color);
    doc.roundedRect(14, yy, 50, groupH, 2.5, 2.5, 'F');
    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(g.title, 39, yy + groupH / 2 + 1.5, { align: 'center' });
    // Badges container
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(68, yy, w - 68 - 14, groupH, 2.5, 2.5, 'F');
    // Badges
    let bx = 74;
    let by = yy + 8;
    g.items.forEach((it) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      const tw = doc.getTextWidth(it) + 8;
      if (bx + tw > w - 16) { bx = 74; by += 11; }
      setFill(doc, BRAND.white);
      setStroke(doc, g.color);
      doc.setLineWidth(0.4);
      doc.roundedRect(bx, by - 4.5, tw, 7, 1.5, 1.5, 'FD');
      setText(doc, g.color);
      doc.text(it, bx + 4, by);
      bx += tw + 3;
    });
  });

  drawFooter(doc, '05');
};

// ---- PAGE 6: CASOS DE ÉXITO ----
const drawCases = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('05  ·  CASOS DE ÉXITO', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.text('Resultados que hablan.', 14, y);

  y += 14;

  const cases = [
    {
      sector: 'FARMACÉUTICO',
      color: BRAND.navy,
      title: 'Distribuidor con 800K transacciones/mes',
      problem: 'Sin capacidad de fijar precios basados en datos: archivos Excel inmanejables, sin lectura de elasticidad.',
      solution: 'Módulo de Mercado con análisis estadístico log-log (β, p-value, R²) sobre toda la historia mensual.',
      result: '+12% en margen bruto en 4 meses · 36 productos sensibles identificados · informe automatizado.',
      kpi: '+12%',
      kpiLabel: 'MARGEN',
    },
    {
      sector: 'CONSUMO MASIVO',
      color: BRAND.green,
      title: 'Operación comercial multi-marca',
      problem: 'Ciclo de contratos en papel de 15 días, riesgo de extravío y firmas manuales fotografiadas.',
      solution: 'Plataforma de Contratos Digitales con firma electrónica dual, certificado hash y propuestas pre-contrato.',
      result: 'Cierre en <24h · 0 contratos perdidos · trazabilidad total · ahorro 80% en costo operativo legal.',
      kpi: '<24h',
      kpiLabel: 'CIERRE',
    },
    {
      sector: 'SAAS B2B',
      color: BRAND.blue,
      title: 'Plataforma con releases semanales',
      problem: 'Regresiones constantes en producción, sin visibilidad de cobertura ni aceptación del cliente.',
      solution: 'QA Test Plans estilo Azure DevOps con trazabilidad de requisitos y aceptación firmada por el cliente.',
      result: '95% pass rate sostenido · −70% bugs en producción · acta de aceptación PDF en cada entrega.',
      kpi: '−70%',
      kpiLabel: 'BUGS',
    },
  ];

  const cardH = 64;
  cases.forEach((c, i) => {
    const yy = y + i * (cardH + 5);
    // Card bg
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(14, yy, w - 28, cardH, 3, 3, 'F');
    // KPI block (left)
    setFill(doc, c.color);
    doc.roundedRect(14, yy, 38, cardH, 3, 3, 'F');
    setFill(doc, c.color);
    doc.rect(48, yy, 4, cardH, 'F');
    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.text(c.kpi, 33, yy + 32, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text(c.kpiLabel, 33, yy + 40, { align: 'center' });
    // Sector tag
    doc.setFontSize(6.5);
    doc.text(c.sector, 33, yy + 52, { align: 'center' });

    // Content (right)
    const cx = 58;
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text(c.title, cx, yy + 10);

    const labelW = 22;
    const txtW = w - cx - 14 - labelW;

    // Problema
    setText(doc, c.color);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('PROBLEMA', cx, yy + 19);
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.text(wrapText(doc, c.problem, txtW), cx + labelW, yy + 19);

    // Solución
    setText(doc, c.color);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('SOLUCIÓN', cx, yy + 35);
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.text(wrapText(doc, c.solution, txtW), cx + labelW, yy + 35);

    // Resultado
    setText(doc, c.color);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('RESULTADO', cx, yy + 51);
    setText(doc, BRAND.green);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(wrapText(doc, c.result, txtW), cx + labelW, yy + 51);
  });

  // Note disclaimer
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(7);
  doc.text('* Casos representativos basados en módulos productivos de la plataforma Analytica. Datos específicos disponibles bajo NDA.',
    14, 280);

  drawFooter(doc, '06');
};

// ---- PAGE 7: CLIENTES ----
// ---- Load image as base64 helper (async) ----
const loadImageAsDataUrl = async (url) => {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
};

const drawFeaturedClients = async (doc) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('07  ·  CASOS DESTACADOS 2026', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.text('Proyectos regionales', 14, y);
  y += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  setText(doc, BRAND.gray);
  doc.text('Tres plataformas en producción para clientes en Ecuador, México y Perú.',
    14, y);

  y += 10;

  const featured = (clientsData.clients || []).filter(c => c.country && c.tagline).slice(0, 3);
  const cardH = 62;
  const gap = 5;
  for (let i = 0; i < featured.length; i++) {
    const client = featured[i];
    const cardY = y + i * (cardH + gap);
    if (cardY + cardH > h - 20) break;

    setFill(doc, BRAND.white);
    setStroke(doc, BRAND.grayLight);
    doc.setLineWidth(0.4);
    doc.roundedRect(14, cardY, w - 28, cardH, 3, 3, 'FD');
    setFill(doc, BRAND.navy);
    doc.rect(14, cardY, 3, cardH, 'F');

    const logoBoxX = 22;
    const logoBoxY = cardY + 6;
    const logoBoxW = 42;
    const logoBoxH = cardH - 12;
    setFill(doc, BRAND.grayLight);
    doc.roundedRect(logoBoxX, logoBoxY, logoBoxW, logoBoxH, 2, 2, 'F');

    try {
      const dataUrl = await loadImageAsDataUrl(client.logo);
      if (dataUrl) {
        const fmt = dataUrl.startsWith('data:image/jpeg') || dataUrl.startsWith('data:image/jpg') ? 'JPEG' : 'PNG';
        doc.addImage(dataUrl, fmt, logoBoxX + 3, logoBoxY + 4, logoBoxW - 6, logoBoxH - 8, undefined, 'FAST');
      } else {
        setText(doc, BRAND.navy);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8);
        doc.text(client.name, logoBoxX + logoBoxW / 2, logoBoxY + logoBoxH / 2, { align: 'center' });
      }
    } catch (e) { /* silent */ }

    const textX = logoBoxX + logoBoxW + 6;
    const textMaxW = w - 14 - textX - 4;
    let ty = cardY + 10;

    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text(client.name, textX, ty);
    const countryText = `${client.flag || ''} ${client.country || ''}`.trim();
    setText(doc, BRAND.gray);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text(countryText, w - 18, ty, { align: 'right' });

    ty += 5;
    setText(doc, BRAND.navy);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    const taglineLines = wrapText(doc, client.tagline || '', textMaxW);
    doc.text(taglineLines, textX, ty);
    ty += taglineLines.length * 4 + 2;

    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    const descLines = wrapText(doc, client.description || '', textMaxW);
    doc.text(descLines.slice(0, 6), textX, ty);

    if (client.stack) {
      setText(doc, BRAND.gray);
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(6.5);
      const stackLines = wrapText(doc, `Stack: ${client.stack}`, textMaxW);
      doc.text(stackLines.slice(0, 2), textX, cardY + cardH - 6);
    }
  }

  drawFooter(doc, '07');
};

const drawRegionalReach = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('08  ·  ALCANCE REGIONAL', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.text('Presencia en Latinoamérica', 14, y);
  y += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  setText(doc, BRAND.gray);
  doc.text('Soluciones tecnológicas entregadas y en producción por país.', 14, y);
  y += 12;

  // 6 país cards con "bandera" + count (2 filas de 3)
  const countries = [
    { name: 'Ecuador', code: 'EC', flag: '🇪🇨', solutions: 10, colors: ['#FFDD00', '#0033A0', '#CE1126'] },
    { name: 'Perú',    code: 'PE', flag: '🇵🇪', solutions: 8,  colors: ['#D91023', '#FFFFFF', '#D91023'] },
    { name: 'México',  code: 'MX', flag: '🇲🇽', solutions: 5,  colors: ['#006847', '#FFFFFF', '#CE1126'] },
    { name: 'Colombia',code: 'CO', flag: '🇨🇴', solutions: 3,  colors: ['#FCD116', '#003893', '#CE1126'] },
    { name: 'USA',     code: 'US', flag: '🇺🇸', solutions: 2,  colors: ['#B22234', '#FFFFFF', '#3C3B6E'] },
    { name: 'Argentina',code:'AR', flag: '🇦🇷', solutions: 2,  colors: ['#75AADB', '#FFFFFF', '#75AADB'] },
  ];

  const cols = 3;
  const cardW = (w - 28 - 2 * 4) / cols; // 3 cards con 2 gaps de 4mm
  const cardH = 56;
  const gap = 4;

  for (let i = 0; i < countries.length; i++) {
    const c = countries[i];
    const row = Math.floor(i / cols);
    const col = i % cols;
    const cx = 14 + col * (cardW + gap);
    const cy = y + row * (cardH + gap);
    // Card
    setFill(doc, BRAND.white);
    setStroke(doc, BRAND.grayLight);
    doc.setLineWidth(0.4);
    doc.roundedRect(cx, cy, cardW, cardH, 3, 3, 'FD');

    // Bandera pintada como 3 franjas horizontales
    const flagY = cy + 6;
    const flagH = 14;
    const flagW = cardW - 10;
    const stripeH = flagH / 3;
    for (let s = 0; s < 3; s++) {
      const hex = c.colors[s];
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      doc.setFillColor(r, g, b);
      doc.rect(cx + 5, flagY + s * stripeH, flagW, stripeH, 'F');
    }
    // Borde bandera
    setStroke(doc, BRAND.grayLight);
    doc.setLineWidth(0.3);
    doc.rect(cx + 5, flagY, flagW, flagH, 'S');

    // País
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(c.name, cx + cardW / 2, flagY + flagH + 7, { align: 'center' });

    // Contador
    setText(doc, BRAND.green);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.text(String(c.solutions), cx + cardW / 2, flagY + flagH + 19, { align: 'center' });

    // Label
    setText(doc, BRAND.gray);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7.5);
    doc.text('soluciones', cx + cardW / 2, flagY + flagH + 25, { align: 'center' });
  }

  y += cardH * 2 + gap + 12;

  // Total banner
  setFill(doc, BRAND.navyDark);
  doc.roundedRect(14, y, w - 28, 22, 3, 3, 'F');
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('30 soluciones entregadas en 6 países', 14 + (w - 28) / 2, y + 10, { align: 'center' });
  setText(doc, '#a3d977');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text('Ecuador · Perú · México · Colombia · USA · Argentina', 14 + (w - 28) / 2, y + 17, { align: 'center' });

  y += 30;

  // Value props debajo
  setText(doc, BRAND.text);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  const values = [
    '• Experiencia comprobada en múltiples industrias (telecom, farma, retail, educación, transporte)',
    '• Diseño culturalmente adaptado a cada país (moneda, idioma local, zonas horarias, regulaciones)',
    '• Producción real, no demos: cada solución opera con usuarios activos las 24 horas',
    '• Soporte y mantenimiento post-entrega con SLA garantizado',
  ];
  values.forEach((v, i) => {
    doc.text(v, 14, y + i * 6, { maxWidth: w - 28 });
  });

  drawFooter(doc, '08');
};

const drawClients = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('06  ·  CLIENTES', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(26);
  doc.text('Confían en nosotros.', 14, y);

  y += 6;
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Empresas líderes en sus industrias que ya operan con nuestra plataforma.',
    14, y + 6);

  y += 22;

  // 4x3 grid of logo placeholders
  const cols = 3;
  const rows = 3;
  const gap = 6;
  const cellW = (w - 28 - gap * (cols - 1)) / cols;
  const cellH = 36;

  const placeholders = [
    'CLIENTE 01', 'CLIENTE 02', 'CLIENTE 03',
    'CLIENTE 04', 'CLIENTE 05', 'CLIENTE 06',
    'CLIENTE 07', 'CLIENTE 08', 'CLIENTE 09',
  ];

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const idx = r * cols + c;
      const x = 14 + c * (cellW + gap);
      const yy = y + r * (cellH + gap);
      // Card
      setFill(doc, BRAND.white);
      setStroke(doc, BRAND.gray);
      doc.setLineWidth(0.4);
      doc.roundedRect(x, yy, cellW, cellH, 2, 2, 'FD');
      // Inner watermark stripe
      setFill(doc, BRAND.grayLight);
      doc.rect(x, yy + cellH - 7, cellW, 7, 'F');
      // Label
      setText(doc, BRAND.gray);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.text(placeholders[idx], x + cellW / 2, yy + cellH / 2 + 1, { align: 'center' });
      // Small mark
      setText(doc, BRAND.green);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6);
      doc.text('logo cliente', x + cellW / 2, yy + cellH - 2, { align: 'center' });
    }
  }

  // Editable note
  setText(doc, BRAND.gray);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(8);
  doc.text('Reemplazar con logos reales de tus clientes en la siguiente versión.',
    14, y + rows * (cellH + gap) + 6);

  drawFooter(doc, '09');
};

// ---- PAGE 10: CONTACTO ----
const drawContact = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();

  // Full bg gradient feel
  setFill(doc, BRAND.navyDark);
  doc.rect(0, 0, w, h, 'F');
  setFill(doc, BRAND.navy);
  doc.triangle(0, 0, w, 0, w, h * 0.5, 'F');
  setFill(doc, BRAND.blue);
  doc.triangle(0, h, 0, h * 0.55, w * 0.7, h, 'F');
  setFill(doc, BRAND.green);
  doc.triangle(w, h, w, h * 0.7, w * 0.6, h, 'F');

  // Big headline
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(48);
  doc.text('Hablemos.', 22, 72);
  setFill(doc, BRAND.green);
  doc.rect(22, 78, 80, 2, 'F');

  setText(doc, [210, 225, 250]);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(13);
  const intro = wrapText(doc,
    'Si llegaste hasta aquí, es porque estás buscando una respuesta seria. Coordinemos una sesión de descubrimiento de 30 minutos —sin costo— y te mostramos cómo aplicaríamos lo de este brochure a tu operación.',
    w - 44);
  doc.text(intro, 22, 95);

  // Contact card
  const cardY = 140;
  const cardX = 22;
  const cardW = w - 44;
  setFill(doc, BRAND.white);
  doc.roundedRect(cardX, cardY, cardW, 90, 4, 4, 'F');
  setFill(doc, BRAND.green);
  doc.rect(cardX, cardY, cardW, 3, 'F');

  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text('Alejandro Amaya', cardX + 8, cardY + 14);
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('CEO · Analytica', cardX + 8, cardY + 21);

  // Contact rows
  const rows = [
    { l: 'WhatsApp', v: '+593 991 466 821' },
    { l: 'Email',    v: 'gerencia@analytica-ec.com' },
    { l: 'Web',      v: 'www.analytica-ec.com' },
    { l: 'Oficina',  v: 'Av. Naciones Unidas y Núñez de Vela, Edif. Metropolitan 3er piso · Quito' },
  ];
  let ry = cardY + 32;
  rows.forEach((r) => {
    setText(doc, BRAND.gray);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text(r.l.toUpperCase(), cardX + 8, ry);
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.text(r.v, cardX + 32, ry);
    ry += 11;
  });

  // CTA pill
  setFill(doc, BRAND.green);
  doc.roundedRect(cardX, cardY + 100, cardW, 18, 9, 9, 'F');
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.text('AGENDA TU SESIÓN DE DESCUBRIMIENTO  ·  GRATIS  ·  30 MIN', cardX + cardW / 2, cardY + 112, { align: 'center' });

  // Brand footer
  setText(doc, BRAND.white);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(18);
  doc.text('ANALYTICA', 22, h - 18);
  setText(doc, [200, 215, 245]);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('Datos. Decisiones. Resultados.', 22, h - 12);
};

// ---- SOLUTIONS PAGE (12 soluciones destacadas) ----
const drawSolutions = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('04  ·  SOLUCIONES', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.text('12 soluciones listas', 14, y);
  y += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  setText(doc, BRAND.gray);
  doc.text('Módulos productivos combinables como piezas de Lego.', 14, y);
  y += 10;

  const solutions = [
    { t: 'Contabilidad SRI Ecuador',   d: 'Sync XML v2.0.0, F-104 IVA, F-103 Retenciones, APS Gastos Personales.' },
    { t: 'Web Scraping a Escala',      d: 'Playwright/Selenium: precios competencia, catálogos, tipos de cambio.' },
    { t: 'Retail & Promociones',       d: 'Motor de reglas: 2x1, combos, cupones, precios dinámicos multi-sucursal.' },
    { t: 'Punto de Venta (POS)',       d: 'POS táctil offline-first, FE SRI, cajas, propinas, pinpad y balanzas.' },
    { t: 'ERP a Medida',               d: 'Inventarios multi-bodega, MRP básico, trazabilidad lote/serie, costeo.' },
    { t: 'IA & Automatización',        d: 'GPT-5, Claude Sonnet 4.5, Whisper, Nano Banana. Clasificación y RPA.' },
    { t: 'Fintech & Pagos',            d: 'PayPhone, Stripe, PayPal, cobros link, conciliación bancaria.' },
    { t: 'Bots WhatsApp / Telegram',   d: 'Pedidos, agendamientos, dispatch, soporte 24/7 con IA contextual.' },
    { t: 'Firma Electrónica PAdES',    d: 'PAdES-B-T, timestamp RFC3161, verificación, .p12 BCE Ecuador.' },
    { t: 'Field Service & Logística',  d: 'OTs, geo-validación, dispatch live, apps móviles técnicos.' },
    { t: 'IoT & Sensores',             d: 'Ingesta MQTT/HTTP, dashboards realtime, alertas por umbral.' },
    { t: 'BI & Dashboards',            d: 'KPIs ejecutivos, cohortes, forecasting con IA, alertas Slack.' },
  ];

  const cols = 2;
  const gap = 4;
  const cardW = (w - 28 - gap) / cols;
  const cardH = 34;

  solutions.forEach((s, i) => {
    const col = i % cols;
    const row = Math.floor(i / cols);
    const cx = 14 + col * (cardW + gap);
    const cy = y + row * (cardH + gap);

    setFill(doc, BRAND.white);
    setStroke(doc, BRAND.grayLight);
    doc.setLineWidth(0.4);
    doc.roundedRect(cx, cy, cardW, cardH, 3, 3, 'FD');

    // Numeración en badge
    setFill(doc, BRAND.navy);
    doc.roundedRect(cx + 4, cy + 4, 12, 8, 1.5, 1.5, 'F');
    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.text(String(i + 1).padStart(2, '0'), cx + 10, cy + 9.2, { align: 'center' });

    // Título
    setText(doc, BRAND.navyDark);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(s.t, cx + 20, cy + 10);

    // Descripción
    setText(doc, BRAND.text);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    const lines = wrapText(doc, s.d, cardW - 10);
    doc.text(lines.slice(0, 3), cx + 5, cy + 18);

    // Accent bar
    setFill(doc, BRAND.green);
    doc.rect(cx, cy, 2, cardH, 'F');
  });

  drawFooter(doc, '04');
};

// ---- INDUSTRIES PAGE ----
const drawIndustries = (doc) => {
  const w = doc.internal.pageSize.getWidth();
  let y = 22;

  setFill(doc, BRAND.green);
  doc.rect(14, y, 12, 1.4, 'F');
  setText(doc, BRAND.green);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('05  ·  INDUSTRIAS', 30, y + 1.2);

  y += 12;
  setText(doc, BRAND.navyDark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(24);
  doc.text('Industrias donde ya operamos', 14, y);
  y += 8;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  setText(doc, BRAND.gray);
  doc.text('12 verticales con implementaciones activas en producción.', 14, y);
  y += 10;

  const industries = [
    'Retail & Supermercados', 'Salud & Farmacia', 'Educación & LMS',
    'Restaurantes & QSR', 'Logística & Transporte', 'Servicios Profesionales',
    'Fintech & Banca', 'Telecomunicaciones', 'Inmobiliaria',
    'Manufactura', 'Consultoría & B2B', 'Turismo & Hospitalidad',
  ];

  const cols = 3;
  const gap = 4;
  const cardW = (w - 28 - 2 * gap) / cols;
  const cardH = 24;

  industries.forEach((name, i) => {
    const col = i % cols;
    const row = Math.floor(i / cols);
    const cx = 14 + col * (cardW + gap);
    const cy = y + row * (cardH + gap);

    setFill(doc, BRAND.navy);
    doc.roundedRect(cx, cy, cardW, cardH, 2.5, 2.5, 'F');

    setText(doc, BRAND.white);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    const lines = wrapText(doc, name, cardW - 8);
    doc.text(lines, cx + cardW / 2, cy + cardH / 2 - (lines.length - 1) * 2, { align: 'center' });
  });

  drawFooter(doc, '05');
};

// ---- MAIN ----
export const generateBrochure = async () => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });

  drawCover(doc);
  doc.addPage();
  drawAbout(doc);
  doc.addPage();
  drawServices(doc);
  doc.addPage();
  drawSolutions(doc);
  doc.addPage();
  drawIndustries(doc);
  doc.addPage();
  drawMethodology(doc);
  doc.addPage();
  drawStack(doc);
  doc.addPage();
  drawCases(doc);
  doc.addPage();
  await drawFeaturedClients(doc);
  doc.addPage();
  drawRegionalReach(doc);
  doc.addPage();
  drawClients(doc);
  doc.addPage();
  drawContact(doc);

  doc.save(`Brochure_Analytica_${new Date().toISOString().slice(0, 10)}.pdf`);
};
